module.exports = __webpack_public_path__ + "img/IMG_0328_L_BlackMatted_MockedUp.50096200.jpg";